var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { withVersion } from '../utils/mediaVersion';
var FallbackProductService = /** @class */ (function () {
    function FallbackProductService() {
    }
    FallbackProductService.prototype.fetchProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // Return sample data when S3 is not available
                return [2 /*return*/, [
                        {
                            id: 'merlot-2017-sample',
                            name: 'Merlot 2017',
                            nameBg: 'Мерло 2017',
                            year: 2017,
                            description: 'A classic Merlot with rich plum and cherry notes, aged in oak barrels for 18 months.',
                            descriptionBg: 'Класическо мерло с богати нюанси на слива и череша, отлежало в дъбови бъчви 18 месеца.',
                            imageUrl: withVersion('/photos/merlot_2017.jpg'),
                            imageFileName: 'merlot_2017.jpg',
                            type: 'Red Wine',
                            region: 'Bulgaria',
                            alcoholContent: '13.5%',
                            priceEUR: 17.85,
                            createdAt: '2024-01-01T00:00:00.000Z',
                            updatedAt: '2024-01-01T00:00:00.000Z'
                        },
                        {
                            id: 'cabernet-2017-sample',
                            name: 'Cabernet Sauvignon 2017',
                            nameBg: 'Каберне Совиньон 2017',
                            year: 2017,
                            description: 'Full-bodied Cabernet with blackcurrant and tobacco notes, perfect for aging.',
                            descriptionBg: 'Пълноценно каберне с нюанси на касис и тютюн, идеално за отлежаване.',
                            imageUrl: withVersion('/photos/cabernet_smaller.jpg'),
                            imageFileName: 'cabernet_smaller.jpg',
                            type: 'Red Wine',
                            region: 'Bulgaria',
                            alcoholContent: '14.0%',
                            priceEUR: 19.38,
                            createdAt: '2024-01-01T00:00:00.000Z',
                            updatedAt: '2024-01-01T00:00:00.000Z'
                        },
                        {
                            id: 'rubin-2018-sample',
                            name: 'Rubin 2018',
                            nameBg: 'Рубин 2018',
                            year: 2018,
                            description: 'Traditional Bulgarian variety with intense ruby color and spicy aromas.',
                            descriptionBg: 'Традиционен български сорт с интензивен рубинен цвят и подправени аромати.',
                            imageUrl: withVersion('/photos/rubin2018_smaller.jpg'),
                            imageFileName: 'rubin2018_smaller.jpg',
                            type: 'Red Wine',
                            region: 'Bulgaria',
                            alcoholContent: '13.0%',
                            priceEUR: 16.32,
                            createdAt: '2024-01-01T00:00:00.000Z',
                            updatedAt: '2024-01-01T00:00:00.000Z'
                        },
                        {
                            id: 'mavrud-2018-sample',
                            name: 'Mavrud 2018',
                            nameBg: 'Мавруд 2018',
                            year: 2018,
                            description: 'Rare Bulgarian grape variety producing deep, complex wines with dark fruit notes.',
                            descriptionBg: 'Рядък български грозде сорт, произвеждащ дълбоки, сложни вина с нюанси на тъмни плодове.',
                            imageUrl: withVersion('/photos/mavrud_2018_smaller.jpg'),
                            imageFileName: 'mavrud_2018_smaller.jpg',
                            type: 'Red Wine',
                            region: 'Bulgaria',
                            alcoholContent: '13.5%',
                            priceEUR: 20.40,
                            createdAt: '2024-01-01T00:00:00.000Z',
                            updatedAt: '2024-01-01T00:00:00.000Z'
                        },
                        {
                            id: 'syrah-2021-sample',
                            name: 'Syrah 2021',
                            nameBg: 'Сира 2021',
                            year: 2021,
                            description: 'Modern Syrah with black pepper and dark berry characteristics.',
                            descriptionBg: 'Модерен сира с характеристики на черен пипер и тъмни горски плодове.',
                            imageUrl: withVersion('/photos/syrah_2021_smaller.jpg'),
                            imageFileName: 'syrah_2021_smaller.jpg',
                            type: 'Red Wine',
                            region: 'Bulgaria',
                            alcoholContent: '13.8%',
                            priceEUR: 18.36,
                            createdAt: '2024-01-01T00:00:00.000Z',
                            updatedAt: '2024-01-01T00:00:00.000Z'
                        },
                        {
                            id: 'rose-2020-sample',
                            name: 'Rosé 2020',
                            nameBg: 'Розе 2020',
                            year: 2020,
                            description: 'Fresh and fruity rosé wine perfect for summer days.',
                            descriptionBg: 'Свежо и плодово розе вино, идеално за летни дни.',
                            imageUrl: withVersion('/photos/Rose2020_smaller.jpg'),
                            imageFileName: 'Rose2020_smaller.jpg',
                            type: 'Rosé Wine',
                            region: 'Bulgaria',
                            alcoholContent: '12.5%',
                            priceEUR: 14.28,
                            createdAt: '2024-01-01T00:00:00.000Z',
                            updatedAt: '2024-01-01T00:00:00.000Z'
                        }
                    ]];
            });
        });
    };
    return FallbackProductService;
}());
export { FallbackProductService };
export var fallbackProductService = new FallbackProductService();
